import { render, staticRenderFns } from "./RemitaResponse.vue?vue&type=template&id=3a23d8be&scoped=true&"
import script from "./RemitaResponse.vue?vue&type=script&lang=js&"
export * from "./RemitaResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23d8be",
  null
  
)

export default component.exports